import Entity from './entity'
export default class Information extends Entity<number>{
}